let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("boRE1")).then(() => parcelRequire('6z8GT'));